import React from 'react';
import PropTypes from 'prop-types';
import Tabs, { Tab } from 'packages/ui/NavigationTabs';

function VirgoolTabs({ activeKey, virgoolId }) {
  return (
    <Tabs>
      <Tab active={activeKey === 'edit'} to={`/virgool/${virgoolId}/edit`}>
        ویرایش اطلاعات
      </Tab>

      {!!virgoolId ? (
        <Tab active={activeKey === 'statistics'} to={`/virgool/${virgoolId}/statistics`}>
          آمار
        </Tab>
      ) : null}
    </Tabs>
  );
}

VirgoolTabs.propTypes = {
  activeKey: PropTypes.oneOf(['statistics', 'edit']),
  virgoolId: PropTypes.number.isRequired || PropTypes.string.isRequired
};

export default VirgoolTabs;
